const actions = {
    SET_STATE: "signUp/SET_STATE",
  };
  
  export default actions;
  